import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Card } from 'antd';
import { VariabilityIndexIconMultifield } from '../../../common/Icons';
import { getVCLabel, getIndexValue } from '../../MapPopup/utils/variabilityIndexHelper';

export const StyledCard = styled(Card)`
  cursor: pointer;
  height: 100%;
  width: 100%;
  //width: fit-content;
  max-width: 100%;
  background: #fff;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
  .ant-card-body {
    display: flex;
    padding: 0px;
  }
`;

export const FieldIconContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-right: 10px;

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  #vi-color {
    border-radius: 3px;
    width: 15px;
    height: 50px;
    background: ${(props) => props.color};
  }
`;

export const TextContainer = styled.div`
  flex-grow: 1;
  min-width: 0;
  font-family: 'Noto Sans SemiBold';
  word-wrap: break-word;
  overflow-wrap: break-word;
}
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #000;
  max-width: 270px;
  font-family: 'Noto Sans SemiBold';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.12px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: #595959;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledValueOne = styled.span`
  font-size: 14px;
  color: #595959;
  font-weight: bold;
`;

export const FieldVariabilityCard = (props) => {
  const { data, VI, fields, handleFieldClickfromCarousal, selectedFieldId } = props;
  const { t } = useTranslation();
  return (
    <StyledCard
      role='button'
      tabIndex={0}
      key={data?.id || ''}
      data-testid='field-card'
      className={`field-card ${selectedFieldId === data?.id ? 'field-card-selected' : ''}`}
      onClick={(e) => {
        handleFieldClickfromCarousal(data);
      }}
    >
      <FieldIconContainer color={fields.find((field) => field.id === data?.id)?.fillColor}>
        <span id='vi-color'></span>
      </FieldIconContainer>
      <TextContainer>
        <Title>{data?.name}</Title>
        <Subtitle>
          <VariabilityIndexIconMultifield />
          {getVCLabel(getIndexValue(VI), t)}
          <StyledValueOne>{getIndexValue(VI)}</StyledValueOne>
        </Subtitle>
      </TextContainer>
    </StyledCard>
  );
};

FieldVariabilityCard.propTypes = {
  data: PropTypes.any,
  VI: PropTypes.any,
  fields: PropTypes.any,
  handleFieldClickfromCarousal: PropTypes.func,
  selectedFieldId: PropTypes.any
};
